// Custom SVG icon components — same interface as Lucide icons (className, style props)
import { ScanSearch } from "lucide-react";

/** App-wide "inspect" affordance (Lucide ScanSearch). */
export const InspectorIcon = ScanSearch;

export const EntireObjectIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="4" y="4" width="7" height="7" rx="1.2" />
    <rect x="13" y="4" width="7" height="7" rx="1.2" />
    <rect x="8.5" y="13" width="7" height="7" rx="1.2" />
    <path d="M11 7.5h2" />
    <path d="M8.5 11v2" />
    <path d="M15.5 11v2" />
  </svg>
);

export const SceneBuilderIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="4" y="4" width="7" height="7" rx="1.2" />
    <rect x="13" y="4" width="7" height="7" rx="1.2" />
    <rect x="6.5" y="13" width="7" height="7" rx="1.2" />
    <path d="M11 7.5h2" />
    <path d="M8.5 11v2" />
    <path d="M15.5 11v2" />
    <path d="M19.5 15.5v5" />
    <path d="M17 18h5" />
  </svg>
);

export const JointIcon = ({ className, style }) => (
  <svg className={className} style={style} viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <circle cx="14" cy="12" r="3" />
    {/* Upper arm: up-left at -140° */}
    <g transform="translate(14, 12) rotate(-140)">
      <rect x="4.5" y="-2" width="9.5" height="4" rx="1" />
    </g>
    {/* Lower arm: down-left at +155° */}
    <g transform="translate(14, 12) rotate(155)">
      <rect x="4.5" y="-2" width="9.5" height="4" rx="1" />
    </g>
  </svg>
);

export const VisualMeshIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="4.5" y="4.5" width="15" height="15" rx="2.5" />
    <path d="M7.5 12c1.35-2.05 3-3.05 4.5-3.05S15.15 9.95 16.5 12c-1.35 2.05-3 3.05-4.5 3.05S8.85 14.05 7.5 12Z" />
    <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none" />
  </svg>
);

export const EllipsoidIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <ellipse cx="12" cy="12" rx="10" ry="6" />
  </svg>
);

// Classic comic-book explosion: 8 spikes radiating from a filled center burst
export const ExplosionIcon = ({ className, style }) => (
  <svg className={className} style={style} viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <polygon points="12,2 13.9,7.4 19.1,4.9 16.6,10.1 22,12 16.6,13.9 19.1,19.1 13.9,16.6 12,22 10.1,16.6 4.9,19.1 7.4,13.9 2,12 7.4,10.1 4.9,4.9 10.1,7.4" />
  </svg>
);

export const BoxGeomIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 4 18.5 7.5v9L12 20l-6.5-3.5v-9L12 4Z" />
    <path d="M5.5 7.5 12 11l6.5-3.5" />
    <path d="M12 11v9" />
  </svg>
);

export const SphereGeomIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="7" />
    <ellipse cx="12" cy="12" rx="7" ry="3.2" />
    <path d="M12 5v14" />
  </svg>
);

export const CapsuleGeomIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <g transform="rotate(-30 12 12)">
      <rect x="4.75" y="8.5" width="14.5" height="7" rx="3.5" />
    </g>
  </svg>
);

export const CylinderGeomIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <ellipse cx="12" cy="7" rx="5" ry="2.5" />
    <path d="M7 7v10" />
    <path d="M17 7v10" />
    <ellipse cx="12" cy="17" rx="5" ry="2.5" />
  </svg>
);

export const HingeJointTypeIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="8" cy="12" r="2.2" />
    <path d="M10.5 12h8" />
    <path d="M16 9.5l2.5 2.5-2.5 2.5" />
  </svg>
);

export const SlideJointTypeIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3.5 12h17" />
    <path d="M6 9.5 3.5 12 6 14.5" />
    <path d="M18 9.5 20.5 12 18 14.5" />
  </svg>
);

export const BallJointTypeIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="4.5" />
  </svg>
);

export const FreeJointTypeIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 4.5v15" />
    <path d="M4.5 12h15" />
    <path d="M12 4.5 10 6.5" />
    <path d="M12 4.5 14 6.5" />
    <path d="M12 19.5 10 17.5" />
    <path d="M12 19.5 14 17.5" />
    <path d="M4.5 12 6.5 10" />
    <path d="M4.5 12 6.5 14" />
    <path d="M19.5 12 17.5 10" />
    <path d="M19.5 12 17.5 14" />
  </svg>
);

export const ActuatorIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Motor housing */}
    <rect x="3" y="7" width="12" height="10" rx="2" />
    {/* Output shaft */}
    <path d="M15 12h6" />
    {/* Winding coil symbol */}
    <path d="M6 12 q1.5-2.5 3 0 q1.5 2.5 3 0" />
  </svg>
);

export const RotationGizmoIcon = ({ className, style, size = 24, ...props }) => (
  <svg
    className={className}
    style={style}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 2v6h-6" />
    <path d="M21 13a9 9 0 1 1-3-7.7L21 8" />
    <circle cx="12" cy="12" r="1.75" fill="currentColor" stroke="none" />
  </svg>
);
